import type { FC } from 'react';

import { Button } from '@xing-com/button';
import type { ButtonProps } from '@xing-com/button';
import { IconButterflyMono } from '@xing-com/icons';

const SignUpButton: FC<ButtonProps> = ({ to = '/start/signup', ...props }) => (
  <Button icon={IconButterflyMono} variant="primary" to={to} {...props} />
);

const SignUpButtonLike: FC<ButtonProps> = ({ ...props }) => (
  <Button icon={IconButterflyMono} variant="primary" {...props} />
);

export { SignUpButton, SignUpButtonLike };
